import * as React from 'react'

import { IconMagicSolid } from '@procurify/ui'

import { GlobalSearchTriggerButtonPlaceholderStyled } from './styles/GlobalSearchTriggerButtonPlaceholderStyled'
import { GlobalSearchTriggerButtonShortcutStyled } from './styles/GlobalSearchTriggerButtonShortcutStyled'
import { GlobalSearchTriggerButtonStyled } from './styles/GlobalSearchTriggerButtonStyled'

export interface IGlobalSearchTriggerButtonProps {
  buttonRef: React.RefObject<HTMLButtonElement>
  ariaLabel: string
  placeholder: string
  shortcutLabel: string
  onClick: () => void
}

export const GlobalSearchTriggerButton = ({
  buttonRef,
  ariaLabel,
  placeholder,
  shortcutLabel,
  onClick,
}: IGlobalSearchTriggerButtonProps) => {
  return (
    <GlobalSearchTriggerButtonStyled
      ref={buttonRef}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <IconMagicSolid size={12} block />
      <GlobalSearchTriggerButtonPlaceholderStyled aria-hidden='true'>
        {placeholder}
      </GlobalSearchTriggerButtonPlaceholderStyled>
      <GlobalSearchTriggerButtonShortcutStyled aria-hidden='true'>
        {shortcutLabel}
      </GlobalSearchTriggerButtonShortcutStyled>
    </GlobalSearchTriggerButtonStyled>
  )
}
